import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { transformUserDetails } from 'utils/DataTransform/User/detail';
import { getLanguageDictionary } from 'reducers/utils';
import BaseDetails from 'containers/Base/BaseDetails';
import Button from 'components/Button';
import { withRouter } from 'react-router';
import UserProfileForm from './Form';
import Assign from 'components/Operational/assign';
import styles from './index.module.scss';
import { toggleModal } from 'reducers/ui';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { getLanguages } from 'reducers/securityCompany';
import i18next from 'i18next';
import { getUserSelectedLanguage } from 'reducers/users';
import { updateUserProfile } from 'reducers/auth';
import { useTranslation } from 'react-i18next';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import { availableLanguages } from 'i18n';

const locales = availableLanguages.reduce((prev, curr) => {
  if (!prev[curr]) {
    // eslint-disable-next-line prefer-template
    prev[curr] = import('dayjs/locale/' + curr + '.js');
  }
  return prev;
}, {});

const setDayJsLocale = language => {
  locales[language].then(() => {
    dayjs.locale(language);
  });
};

const useStyles = makeStyles(theme => ({
  formPaper: {
    position: 'absolute',
    right: 0,
    top: 60,
    zIndex: 100,
    width: '40%',
    height: '87%',
    background: 'none',
    [theme.breakpoints.down('md')]: {
      left: '50%',
      width: '50%',
      top: '9%',
    },
  },
  detailPanel: {
    right: 0,
    top: 65,
    zIndex: 99,
    height: '90vh',
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
  },
}));

const UserProfile = ({ history, logout, cancel }) => {
  const { t } = useTranslation();
  // selectors
  const user = useSelector(state => state.user);
  const languageList = useSelector(state => getLanguageDictionary(state));
  const profileModal = useSelector(state => state.ui.modalOpen.profile);
  const listOfLanguages = useSelector(state => getLanguages(state));
  const selectedLanguage = useSelector(state => getUserSelectedLanguage(state));
  // hooks
  setDayJsLocale(selectedLanguage);
  const [selectedLanguageId, setSelectedLanguageId] = useState(
    selectedLanguage,
  );
  const classes = useStyles();
  // actions
  const dispatch = useDispatch();
  const dispatchToggleform = useCallback(
    () => dispatch(toggleModal('profile')),
    [dispatch],
  );

  const dispatchUpdateUserProfile = useCallback(
    data => dispatch(updateUserProfile(data)),
    [dispatch],
  );

  const transformUserData = () => {
    return transformUserDetails({
      data: user,
      languageList,
    });
  };

  const changePwd = () => {
    history.push('/change-pwd');
  };

  useEffect(() => {
    i18next.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const translatedOptions = listOfLanguages.map(m => {
    return {
      ...m,
      label: t(m.label),
    };
  });

  // when you set the language, click update to make a api call to set language
  const operationalComponent = () => {
    return (
      <div className={styles.detailInfo}>
        {
          <Assign
            label="Preferred Language"
            placeholder="Select Language"
            options={translatedOptions}
            selectedValue={selectedLanguageId}
            changeSelectedValue={({ id }) => {
              setSelectedLanguageId(id);
            }}
            btnText={'Update'}
            btnSize={'s'}
            btnColor={'primary'}
            btnClick={() => {
              dispatchUpdateUserProfile({
                settings: {
                  i18n: selectedLanguageId.toUpperCase(),
                },
              });
            }}
          />
        }
        <div className={styles.operational}>
          <div className={styles.buttonRow}>
            <Button
              type="button"
              text="Log out"
              size="l"
              onClick={logout}
              color="secondary"
            />
            <Button
              type="button"
              text="Change Password"
              size="l"
              onClick={changePwd}
              color="primary"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <Portal id="portal"> */}
      <BaseDetails
        header="Profile"
        details={transformUserData()}
        cancel={cancel}
        operationComponent={operationalComponent()}
        className={classes.detailPanel}
        editable
        onEdit={dispatchToggleform}
        editHoverText={translatedKeyValueText('edit_value_title', {
          value: user.general.firstName,
        })}
      />
      {profileModal && (
        <Paper className={classes.formPaper}>
          <UserProfileForm
            userData={transformUserData()}
            closeForm={dispatchToggleform}
          />
        </Paper>
      )}
      {/* </Portal> */}
    </>
  );
};

UserProfile.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  logout: PropTypes.func,
  cancel: PropTypes.func,
};

export default withRouter(UserProfile);
